import { rootMargin } from '@helpers/animate';
import { highlightTitleWords } from '@helpers/utils';
import { withMotion } from '@hoc/withMotion';
import { useInView } from '@hooks/useInView';
import React from 'react';
import { AwardsBannerStyles as S } from './AwardsBanner.styles';
export var TitlePlacement;
(function (TitlePlacement) {
    TitlePlacement[TitlePlacement["TOP"] = 0] = "TOP";
    TitlePlacement[TitlePlacement["CENTERED"] = 1] = "CENTERED";
})(TitlePlacement || (TitlePlacement = {}));
export var AwardsBannerTheme;
(function (AwardsBannerTheme) {
    AwardsBannerTheme[AwardsBannerTheme["LIGHT"] = 0] = "LIGHT";
    AwardsBannerTheme[AwardsBannerTheme["GREY"] = 1] = "GREY";
})(AwardsBannerTheme || (AwardsBannerTheme = {}));
const AwardsBanner = ({ title, titlePlacement = TitlePlacement.TOP, variant = AwardsBannerTheme.LIGHT, awards, pageContext, }) => {
    const [containerRef, inView] = useInView({ rootMargin }, false, pageContext?.isEditMode);
    const getGridLayout = (_awards, split) => {
        return (React.createElement(S.GridLayout, { "data-title-placement": titlePlacement, "data-split": split }, _awards.map((award, i) => (React.createElement(S.Award, { key: `AwardsBanner_${i}`, ...(award.link
                ? { as: 'a', href: award.link.url, target: award.link.target, title: award.link.text }
                : {}) }, award.image ? (React.createElement("img", { src: award.image.src, alt: award.altText, loading: "lazy" })) : (React.createElement("iframe", { src: award.iframeUrl, "aria-label": "Embedded award" })))))));
    };
    return (React.createElement(S.Container, { variant: variant === AwardsBannerTheme.GREY ? 'stone' : 'white', ref: containerRef, "data-variant": variant, "data-title-placement": !title && variant === AwardsBannerTheme.LIGHT && awards.length >= 4
            ? TitlePlacement.TOP
            : titlePlacement },
        React.createElement(S.MotionWrapper, { "data-in-view": inView },
            titlePlacement === TitlePlacement.TOP && (React.createElement(React.Fragment, null,
                title && React.createElement(S.Title, { dangerouslySetInnerHTML: { __html: highlightTitleWords(title) } }),
                getGridLayout(awards, false))),
            titlePlacement === TitlePlacement.CENTERED && (React.createElement(React.Fragment, null,
                getGridLayout(awards.slice(0, 4), true),
                title && React.createElement(S.Title, { dangerouslySetInnerHTML: { __html: highlightTitleWords(title) } }),
                getGridLayout(awards.slice(4), true))))));
};
export default withMotion(AwardsBanner);
